export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11062.928bf010.jpg";